<template>
  <!-- Modal -->
  <div
    class="modal fade"
    id="buildPlaylistModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="buildPlaylistModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="buildPlaylistModalLabel">
            {{ $t("label.buildAPlaylist") }}
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form id="playlistForm">
            <div class="form-row justify-content-start">
              <div
                class="col-sm-12 col-md-4"
                v-for="cate in categories"
                :key="cate.slug"
              >
                <div class="custom-control custom-checkbox d-flex">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    :id="cate.slug"
                    :name="cate.slug"
                  />
                  <label class="custom-control-label" :for="cate.slug">{{
                    get(cate, `${locale}.name`)
                  }}</label>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button @click.prevent="submitForm">
                {{ $t("button.createPlaylist") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import $ from "jquery";
import Cookies from "js-cookie";
import { get } from "lodash";
export default {
  computed: {
    ...mapState({
      categories: "categories",
    }),
    locale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    get,
    submitForm() {
      $("#buildPlaylistModal").modal("hide");
      const playList = $("#playlistForm")
        .serializeArray()
        .reduce((obj, item) => {
          obj.push(item.name);
          return obj;
        }, []);
      Cookies.set("playlist_show", playList, {
        expires: 7,
        path: "/",
        sameSite: "None",
        secure: true,
      });
      localStorage.setItem("playlist_show", JSON.stringify(playList));
      this.$router.push({
        name: "playListShow",
        params: {
          locale: this.locale,
        },
      });
    },
  },
};
</script>
<style lang="scss">
#buildPlaylistModal .modal-dialog {
  width: 90%;
  max-width: 1140px;
  .modal-footer {
    margin-top: 20px;
    justify-content: center;
  }
}
</style>
